import React from 'react';
import { Box } from 'lucide-react';
import { Product } from '../../types/product';
import { formatStoreName } from '../../utils/formatters';

interface RecentProductsListProps {
  products: Product[];
  onSelectProduct: (productId: string) => void;
}

const RecentProductsList: React.FC<RecentProductsListProps> = ({
  products,
  onSelectProduct
}) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 p-4">
      {products.slice(0, 4).map(product => (
        <div
          key={product.id}
          onClick={() => onSelectProduct(product.id)}
          className="group relative aspect-[4/3] md:aspect-square bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer overflow-hidden"
        >
          {/* Product Image */}
          <div className="absolute inset-0">
            {product.images.length > 0 ? (
              <img
                src={product.images[0].url}
                alt={product.basicInfo.title}
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null;
                  target.style.display = 'none';
                }}
              />
            ) : (
              <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                <Box className="h-8 w-8 text-gray-400" />
              </div>
            )}
          </div>
          
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors" />
          
          {/* Content */}
          <div className="absolute inset-0 p-4 flex flex-col justify-end">
            <div className="bg-black/60 p-2 md:p-3 rounded-lg">
              <h3 className="font-medium text-white text-sm md:text-base line-clamp-2">
                {product.basicInfo.title}
              </h3>
              <div className="text-xs md:text-sm text-white/80 mt-0.5 md:mt-1">
                {formatStoreName(product.storeName)}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentProductsList;